import { render, staticRenderFns } from "./SlasListItem.vue?vue&type=template&id=3d3a65ca&scoped=true&"
import script from "./SlasListItem.vue?vue&type=script&lang=js&"
export * from "./SlasListItem.vue?vue&type=script&lang=js&"
import style0 from "./SlasListItem.vue?vue&type=style&index=0&id=3d3a65ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3a65ca",
  null
  
)

export default component.exports